import { Button, Dialog, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ProjectConfig } from "Global";
import { ApiRequest } from "GlobalFunctions";

export default function NeighborhoodEditor(props: any) {
  const { setLoading, openEditor, setOpenEditor, neighborhood_id, loadList } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    neighborhood_id: neighborhood_id ? neighborhood_id : "null",
    neighborhood: "",
    neighborhood_code: "",
  };

  const [formValues, setFormValues] = useState(defaultValues);

  useEffect(() => {
    if (neighborhood_id) {
      axios.get(`${ProjectConfig.api_url}/neighborhoods/details`, {
        params: { neighborhood_id },
      })
      .then((response) => {
        if(response.data.status === "success"){
          setFormValues(response.data.data);
        }
      })
      .catch((err) => console.log(err.response));
    } else {
      setFormValues(defaultValues);
    }
  }, [neighborhood_id]);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const body = new FormData();
    body.append("formValues", JSON.stringify(formValues));

    await ApiRequest({
      url: "/neighborhoods/addedit",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body: body,
      setResponse: (response: any) => {
        if(response.status === "success"){
          enqueueSnackbar('Barrio guardado con éxito', { variant: 'success' });
          setOpenEditor(false);
          loadList();
        } else {
          enqueueSnackbar(response.message, { variant: 'error' });
        }
        setLoading(false);
      },
    });
  };

  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)}>
      <div className="DialogContainer" style={{ maxWidth: '502px' }}>
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Barrio</h2>
              <span className="h2_subtitle">Editar</span>
            </div>
          </div>

          <div className="input_group">
            <TextField
              id="neighborhood"
              name="neighborhood"
              label="Nombre del Barrio"
              type="text"
              required
              fullWidth
              value={formValues.neighborhood}
              onChange={handleInputChange}
            />

            <TextField
              id="neighborhood_code"
              name="neighborhood_code"
              label="Código del Barrio"
              type="text"
              required
              fullWidth
              value={formValues.neighborhood_code}
              onChange={handleInputChange}
            />
          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">
              Cancelar
            </Button>
            <Button onClick={handleSubmit} variant="contained">
              Guardar
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
